export const APPOINTMENT_COFNIG_HEADER = {
  "Content-Type": "application/json",
  Accept: "application/json",
  "Request-Type": "READ",
  Function: "APPOINTMENT_CONFIG",
};
